import * as apiBrowsingHistory from '@/api/browsing-history'
import * as _ from 'lodash'
import store from '@/store'
import { isFromAdminSystem } from '@/util/common'

const getDefaultState = () => {
  const defaults = {
    lists: [],
    complete: false,
    canload: true,
    start: 0,
    per_page: 100,
    count: null,
    currentId: null
  }

  return defaults
}

const browsingHistory = {
  // plugins: [createPersistedState({ key: 'lc-app' })], // LocalStorageに保存する場合はコメント解除
  namespaced: true,
  state: getDefaultState(),
  getters: {
    getCurrentList: (state) => _.find(state.lists, list => list.id === state.currentId)
  },
  mutations: {
    setLists: (state, lists) => {
      state.lists.push(...lists)
    },
    setStart: (state, num) => {
      state.start = num
    },
    deleteCount: (state) => {
      state.count = 0
    },
    setCount: (state, num) => {
      if (num > state.per_page) {
        state.count = state.per_page
      } else {
        state.count = num
      }
    },
    subtractionCount: (state) => {
      state.count--
    },
    setComplete: (state) => {
      state.complete = true
    },
    setCanload: (state, boolean) => {
      state.canload = boolean
    },
    resetLists: (state) => {
      state.lists.splice(0, state.lists.length)
    },
    resetComplete: (state) => {
      state.complete = false
    },
    resetAll: (state) => {
      Object.assign(state, getDefaultState())
    },
    setId: (state, id) => {
      state.currentId = id
    },
    deleteList: (state, index) => {
      state.lists.splice(index, 1)
    },
    setUserImage(state, list) {
      const index = state.lists.findIndex((u) => u.id === list.id)
      const tmpLsists = state.lists
      tmpLsists[index] = list
      state.lists = [...tmpLsists]
    }
  },
  actions: {
    getCount: ({ commit, state }) => {
      const params = {
      }
      apiBrowsingHistory
        .count(params)
        .then(response => {
          const { data } = response
          if (data.status === 0) {
            commit('setCount', data.count)
          }
        })
    },
    getLists: async ({ commit, state, dispatch }) => {
      commit('resetLists')

      const params = {
        start: state.start,
        per_page: state.per_page,
        search_order: 'created', // created(作成日順)
        ascending: 'desc'
      }

      if (state.canload) {
        commit('setCanload', false)
        const res = await apiBrowsingHistory
          .list(params)
          .then(async(response) => {
            const { data } = response
            if (data.status === 0) {
              const { lists } = data

              // 画像設定しているユーザーのアイコンを設定する 
              _.forEach(_.filter(lists, list => list.user_file_id && list.user_file_id !== store.state.profile.user_icon), (list) => {
                dispatch('getFile', list.user_file_id, { root: true }).then(res => {
                  commit('setUserImage', { ...list, image: res.dataUrl })
                })
              })

              // 初期表示時に全件取得
              await commit('setLists', lists)
              commit('setCanload', true)
              commit('setComplete')
              dispatch('getCount')
            } else {
              if (!isFromAdminSystem()) {
                // status=その他: エラーダイアログを表示
                store.dispatch('common/showNotice', { title: 'エラー', text: response.data.error_message })
              }
            }
            return data
          })
        return res
      }
    },
    setEditId: async ({ commit }, id) => {
      await commit('setId', id) 
    },
    delete: async ({ commit, state }, params) => {
      await apiBrowsingHistory
        .remove(params)
        .then(response => {
          const { data } = response
          if (data.status === 0) {
            const index = _.findIndex(state.lists, list => list.history_id === params.id)
            commit('deleteList', index)
            commit('subtractionCount')
          }
        })
    },
    deleteAll: async ({ commit, state }, params) => {
      await apiBrowsingHistory
        .remove(params)
        .then(response => {
          const { data } = response
          if (data.status === 0) {
            commit('resetLists')
            commit('deleteCount')
            commit('setComplete')
          }
        })
    }
  }
}

export default browsingHistory
